import {
	LOGIN_SUCCEEDED,
  LOGIN_FAILED,
  LOGOUT_FAILED,
  LOGOUT_SUCCEEDED,
	VENDOR_LOADED
} from './types'

import axios from 'axios';
import { Vendor_ApiKey, ServerPath } from '../tempfile';


export const login = ({ username, password, clientId }) => {
  return (dispatch, getState) => {

    const requestBody = {
        API_key: Vendor_ApiKey,
        user: username,
        password: password
    };

    if (clientId) {
        requestBody.client_id = clientId;
    }

		console.log(requestBody)
    return axios.post(ServerPath + `/api/login`, requestBody).then(response => {
			console.log(response)
        if (!response.data.success) {
          dispatch({ type: LOGIN_FAILED });
          return Promise.resolve(false);
        }else{
          dispatch({ type: LOGIN_SUCCEEDED, payload: response.data.token });
					window.localStorage.setItem('username', JSON.stringify(username));
					window.localStorage.setItem('password', JSON.stringify(password));
					console.log("token saved")
          return Promise.resolve(true);
        }
    });
  }
};

export const renewToken = (token, expiration) => {
	return (dispatch, getState) => {
		if(token !== null && expiration && parseInt(expiration) > new Date().getTime()){
			dispatch({ type: LOGIN_SUCCEEDED, payload: token });
			return Promise.resolve(true);
		}else{
			dispatch({ type: LOGIN_FAILED });
			return Promise.resolve(false);
		}
	}
};

export const logout = (token) => {
	console.log("logout")
	console.log(token)
  return (dispatch) => {
    return axios.post(ServerPath + `/api/logout`, { token }).then(response => {
      if (!response.data.success) {
        dispatch({ type: LOGOUT_FAILED });
				console.log("log out failed")
        return Promise.resolve(false);
      }else{
        dispatch({ type: LOGOUT_SUCCEEDED });
				window.localStorage.removeItem('username');
				window.localStorage.removeItem('password');
				console.log("logged out")
        return Promise.resolve(true);
      }
    });
  }
};

export const getVendor = () => {
  return (dispatch, getState) => {

		const {apiToken} = getState().auth;

    return axios.post(ServerPath + `/api/getVendor`, { token: apiToken }).then(response => {
			console.log(response)
      if (!response.data.success) {
        dispatch({ type: VENDOR_LOADED, payload: null });
        return Promise.resolve(false);
      }else{
        dispatch({ type: VENDOR_LOADED, payload: response.data.vendor });
        return Promise.resolve(true);
      }
    });
  }
};
